import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  BREAKPOINTS,
  COLORS,
  PageWidth,
  SystemIcon,
  SystemIcons,
} from '@laerdal/life-react-components';
import BreadcrumbTopSection from '../../commonComponents/BreadcrumbTopSection';
import { selectMarket, buildMarketPath } from '../../store/slices/globalConfigSlice';
import { useNavigate } from 'react-router-dom';
import { QcprModalLink } from './components';
import posthog from 'posthog-js';

const QcprSupportContainer = styled.div`
  margin: 0 0 32px 0;
  gap: 32px;
  display: flex;
  flex-direction: column;
`;

const PageContainer = styled.div`
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
`;

const PageTitleContainer = styled.div`
    display: flex;
    max-width: 640px;
    flex-direction: column;
    gap: 8px;
    align-self: stretch;
`;

const PageTitle = styled.div`
    color: ${COLORS.black};
    font-feature-settings: 'liga' off;

    /* S - Mobile/H5 */
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 28.8px */
`;

const PageSubTitle = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: ${COLORS.neutral_600};
`;

const QcprSupportPage = () => {
  const { t } = useTranslation(['translation', 'qcprSupport']);
  const currentMarket = useSelector(selectMarket);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('SUPP-QcprSupport-PageVisit');


    // Track page visit
    posthog.capture('SUPP-QcprSupport-PageVisit', {
      page: 'QcprSupportLanding',
      market: currentMarket
    });
  }, [currentMarket]);

  const handleSuggestionsClick = () => {
    posthog.capture('SUPP-QcprSupport-SuggestionsSelected', {
      source_page: 'QcprSupportLanding',
      market: currentMarket
    });
    navigate(buildMarketPath(currentMarket, '/qcpr-support/suggestions'));
  };

  const handleTroubleshootingClick = () => {
    posthog.capture('SUPP-QcprSupport-TroubleshootingSelected', {
      source_page: 'QcprSupportLanding',
      market: currentMarket
    });
    navigate(buildMarketPath(currentMarket, '/qcpr-support/troubleshooting'));
  };


  return (
    <>

      <PageWidth $useMaxWidth={true} $maxWidth={1024}>
        <PageContainer>
          <PageTitleContainer>
            <PageTitle>{t('How can we help you?', { ns: 'qcprSupport' })}</PageTitle>
            <PageSubTitle>{t('Choose the option that best describes what you need help with', { ns: 'qcprSupport' })}</PageSubTitle>
          </PageTitleContainer>

          <QcprSupportContainer>
            <QcprModalLink
              title={t('Have suggestions?', { ns: 'qcprSupport' })}
              description={t("Questions about research, bulk orders, partnerships, or anything else, we're here to help.", { ns: 'qcprSupport' })}
              onClick={handleSuggestionsClick}
              icon={SystemIcons.Mail}
            />


            <QcprModalLink
              title={t("Something isn't working", { ns: 'qcprSupport' })}
              description={t(`Troubleshooting  will try to resolve the problem. If it's not, we'll use your answers to create a support case`, { ns: 'qcprSupport' })}
              onClick={handleTroubleshootingClick}
              icon={SystemIcons.SpeechBuble}
            />

          </QcprSupportContainer>
        </PageContainer>
      </PageWidth>
    </>
  );
};

export default QcprSupportPage;
